<template>
  <div>
    <el-dialog
      title="新增备注"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
      v-dialogDrag
      @close="close"
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="60px"
      >
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="4"
            v-model="dataObj.remark"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" v-preventReClick="5000" :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkAdd('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 中差评新增备注弹窗
 * 功能：按 platform 区分调用 Amazon/eBay 备注接口，为中差评记录新增备注。
 * 备注：组件 name 为 "add"，疑似复制残留命名。
 */
import { addRemark, addEbayRemark } from "@/api/user";
export default {
  name: "add",
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 平台id 1：Amazon；2：ebay
    platform: {
      type: Number,
      default: () => {
        return 1;
      },
    },
  },
  data() {
    return {
      // 按钮禁用状态（定义了未用）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
      // 备注提交数据（记录 id/备注内容）
      dataObj: {
        id: "",
        remark: "",
      },
      rules: {
        remark: [
          {
            required: true,
            message: "请填写备注",
            trigger: "blur",
          },
        ],
      },
    };
  },
  /** 打开弹窗时将已有备注预填进提交数据 */
  created() {
    this.dataObj.remark = this.scope.remark;
  },
  methods: {
    /** 关闭弹窗并通知父组件 */
    close() {
      this.dialogFormVisible = false;
      this.$emit("isShowEdit");
    },
    /** 校验表单后按平台调用备注新增接口，成功后关闭弹窗并刷新列表
     * @param {String} formName 表单 ref 名称
     */
    checkAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataObj.id = this.scope.id;
          if (this.platform === 1) {
            // 亚马逊中差评列表-添加备注
            addRemark(this.dataObj).then((result) => {
              if (result.code == 200) {
                this.dialogFormVisible = false;
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.$emit("getList");
              }
            });
          } else {
            // ebay中差评列表-添加备注
            addEbayRemark(this.dataObj).then((result) => {
              if (result.code == 200) {
                this.dialogFormVisible = false;
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.$emit("getList");
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>